import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/191/components/features/cases/OldComponents/cases/gapresurs/index.js");
